import React, { useState } from 'react';
import { IOrderFormData, IOrder, ORDER_STATUS, IOrderDetails } from 'models/ordersModel';
import { CircleFill } from 'react-bootstrap-icons';
import OrderInvoiceListItem from './OrderInvoiceListItem';
import UpdateOrderModal from './modals/UpdateOrderModal';
import { StatusClassItem } from 'models/commonModel';
import { getLocalDate, getStatusClass } from 'utils/utils';
import useNotify from 'utils/useNotify';
import { useGetOrderById, useUpdateOrder } from 'services/orders/ordersServices';
import T from 'utils/useLocalizer';
import { useLanguage } from 'utils/useLanguage';

interface Props {
  item: IOrder;
}

const OrdersListItem = ({ item }: Props) => {
  const { notifyInfo, notifySuccess } = useNotify();
  const { language } = useLanguage();

  const [openModal, setOpenModal] = useState<boolean>(false)
  const { mutateAsync: updateAsync, isLoading: isLoadingUpdate } = useUpdateOrder()
  const { data: orderDetails, isFetching: isFetchingOrder, isLoading, refetch } = useGetOrderById(item.id, language);
  const [currentItem, setCurentItem] = useState<IOrderDetails | undefined>();

  const resources = {
    updateSuccessMessage: T('order.update.success.message')
  }
  const orderStatusClasses: Array<StatusClassItem> = [
    {
      status: ORDER_STATUS.Confirmed,
      className: 'badge bg-light-blue',
    },
    {
      status: ORDER_STATUS.Completed,
      className: 'badge bg-light-green',
    },
    {
      status: ORDER_STATUS.Cancelled,
      className: 'badge bg-light-red',
    },
  ];

  const onSubmitUpdateOrder = async (id: number, data: IOrderFormData, isNotify: boolean, isStatusChanged: boolean, notificationPhoneNumber?: string, phoneNumber?: string, waTemplateId?: number
    , templateName?: string, templateLanguage?: string) => {
    await updateAsync({ id: id, data: data, isNotify, isStatusChanged, notificationPhoneNumber, phoneNumber, waTemplateId, templateName, templateLanguage })
      .then(() => {
        notifySuccess(resources.updateSuccessMessage)
        setOpenModal(false)
        return true
      })
      .catch(() => { return false })
  };

  const onClickOpenUpdateModal = async () => {
    const { data } = await refetch()
    if (data) {
      setCurentItem(data);
      setOpenModal(true)
    }
  }

  return (
    <>
      <tr>
        <td className="fw-bold text-primary cursor-pointer" onClick={onClickOpenUpdateModal}>#{item.orderNo}</td>

        <td className='cursor-pointer' onClick={onClickOpenUpdateModal}>
          <div>{item.customerName}</div>
          <div className="text-muted small">
            {item.phoneNumber?.replace(/^(\+)?0+/, '')}
          </div>
        </td>

        {/* Total */}
        <td className='cursor-pointer' onClick={onClickOpenUpdateModal}>
          <span className="fw-bold">{item.amount.toFixed(2)}</span> <span className='text-muted small'>{item.currency}</span>
        </td>

        {/* Status */}
        <td className='cursor-pointer' onClick={onClickOpenUpdateModal}>
          <span className={`${getStatusClass(item.orderSystemStatusId, orderStatusClasses, {
            defaultClass: 'badge bg-light-blue'
          })} p-2 rounded-pill text-xs`}>
            <CircleFill width={7} height={6} /> {item.statusName}
          </span>
        </td>

        {/* Note */}
        <td className='cursor-pointer text-truncate' style={{maxWidth:"250px"}} 
        onClick={onClickOpenUpdateModal} title={item?.note}>
          {item.note || '---'}
          </td>

        {/* Date */}
        <td className='p-3 text-muted cursor-pointer' dir='ltr' onClick={onClickOpenUpdateModal}>{item.createdOn ? getLocalDate(item.createdOn, "DD MMM YYYY hh:mm A") : '_'}</td>


        {/* Invoice */}
        <td>
          <OrderInvoiceListItem
            orderId={item.id}
            orderNumber={item.orderNo}
            isSent={item.isInvoiceSent}
            sentOn={item.invoiceSentOn}
            hasNotificationPhoneNumber={item.hasNotificationPhoneNumber}
            hasInvoiceTemplate={item.hasInvoiceTemplate}
            recipientPhoneNumber={item.phoneNumber}
          />
        </td>
      </tr>

      <UpdateOrderModal item={currentItem}
        isLoading={isLoading}
        isFetchingOrder={isFetchingOrder}
        systemStatusId={item.orderSystemStatusId}
        id={item.id} show={openModal}
        onSubmit={onSubmitUpdateOrder}
        setOpenUpdateModal={setOpenModal}
      />
    </>
  );
};

export default OrdersListItem;